import { Component, EventEmitter, h, Prop, Event, ComponentInterface } from '@stencil/core';
import Alert from 'bootstrap/js/src/alert';

@Component({
	tag: 'kdx-alert',
	styleUrl: 'kdx-alert.scss',
	shadow: false,
})
export class StAlert implements ComponentInterface {

	/**
	 * Assigns a required unique id to the general alert
	 */
	@Prop() alertId: string = "genericAlertId";

	/**
	 * Provides a string of any additional classes for the alert item
	 */
	@Prop() alertClasses: string = "alert-primary";

	/**
	 * Optional alert icon, set via the `<kdx-icon>` component
	 */
	@Prop() alertIcon: string;

	/**
	 * Provides a string of classes for the alert's dismiss button
	 */
	@Prop() btnClasses: string = "btn-close";

	/**
	 * Provides input to change text of alert's dismiss button, btnClasses should also be provided when using this.
	 */
	@Prop() btnText: string = "";

	/**
     * Optional Icon for the primary button
     */
    @Prop() btnIcon: string;

	/**
	 * Provides input to change URL of alert's second button
	 */
	@Prop() btnTwoHref: string;

	/**
	 * Provides a string of classes for the alert's optional second button
	 */
	@Prop() btnTwoClasses: string;

	/**
	 * Provides input to change label of alert's second button; btnTwoClasses should also be provided when using this.
	 */
	@Prop() btnTwoLabel: string;

	/**
	 * Provides input to change text of alert's second button; btnTwoClasses should also be provided when using this.
	 */
	@Prop() btnTwoText: string;

	/**
	 * Provides input to change icon of alert's second button; btnTwoClasses should also be provided when using this.
	 */
	@Prop() btnTwoIcon: string;

	/**
	 * Determines if the alert should use dismissible utilities
	 */
	@Prop() dismissible: boolean = false;

	/**
	 * Event is triggered when button clicked
	 */
	@Event() dismissTriggered: EventEmitter;
	dismissTriggeredHandler() {
		this.dismissTriggered.emit();
	}

	componentWillLoad() {
		if (this.dismissible) {
			let alertElement = document.getElementById(this.alertId);
			new Alert(alertElement);
		}

		// Make sure the alert knows to add padding
		// for the icon (left default)
		if (this.alertIcon) {
			this.alertClasses = this.alertClasses + ' has-icon';
		}
	}

	render() {
		if (this.dismissible) {
			return (
				<div id={this.alertId} class={`alert ${this.alertClasses} alert-dismissible fade show`} role="alert">
					<div class="container">
						{(this.alertIcon) &&
							<span class="alert-icon svg-icon">
								<kdx-icon icon={this.alertIcon} />
							</span>
						}
						<slot />
						<div class="cookie-links">
							<button type="button" class={this.btnClasses} data-bs-dismiss="alert" aria-label={this.btnText} onClick={() => this.dismissTriggeredHandler()}>
							{(this.btnIcon) && (
									<span class="svg-icon">
                                        <kdx-icon icon={this.btnIcon} />
                                    </span>
                                )}
								{this.btnText}
							</button>
							{(this.btnTwoHref) &&
								<a href={this.btnTwoHref} class={this.btnTwoClasses} aria-label={this.btnTwoLabel}>
									{(this.btnTwoIcon) ?
										<span>{this.btnTwoText}<span class="svg-icon"><kdx-icon icon={this.btnTwoIcon} /></span></span> :
										this.btnTwoText
									}
								</a>
							}
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div id={this.alertId} class={`alert ${this.alertClasses}`} role="alert">
					<div class="container">
						<slot />
					</div>
				</div>
			);
		}
	}
}